import { render, staticRenderFns } from "./ElementOverviewElementGroup.vue?vue&type=template&id=160e2570&"
import script from "./ElementOverviewElementGroup.vue?vue&type=script&lang=js&"
export * from "./ElementOverviewElementGroup.vue?vue&type=script&lang=js&"
import style0 from "./ElementOverviewElementGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports